import * as React from 'react';
import { SVGProps } from 'react';

const SvgPulse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        d="M19.427 34.036h-.002c-.249 0-.49-.09-.677-.253l-.011-.01-.012-.009-.344-.275C13.4 29.182 9.673 25.283 7.198 21.816c-2.485-3.48-3.656-6.451-3.656-8.914 0-2.518.841-4.552 2.252-5.955 1.411-1.403 3.451-2.233 5.956-2.233 2.41 0 4.302.736 5.696 2.134l.003.003c.522.52.965 1.113 1.314 1.762l.655 1.217.664-1.212c1.142-2.086 3.249-3.904 7.016-3.904 2.55 0 4.582.82 5.975 2.213 1.392 1.392 2.212 3.424 2.212 5.975 0 2.49-1.169 5.46-3.652 8.933-2.476 3.462-6.206 7.351-11.202 11.663l-.33.284-.004.004a1.012 1.012 0 0 1-.67.25Zm-1.17.314c.324.28.738.435 1.167.436l-1.167-.436Z"
      />
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        d="M4.5 23.5h8l3-8 4 9 4-6 4 4"
      />
      <path
        fill={props.fill}
        d="M37.188 20.763v5.05l-7.654.025-5.035-5.03 12.689-.045Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M0 0h34.375v30.822H0z"
          transform="translate(2.813 3.964)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgPulse;
